import { Component, OnInit } from '@angular/core';
import { TerminosYCondicionesModalComponent } from '../terminos-y-condiciones-modal/terminos-y-condiciones-modal.component';

@Component({
  selector: 'app-footer-new',
  templateUrl: './footer-new.component.html',
  standalone: true,
  styleUrls: ['./footer-new.component.css'],
  imports: [TerminosYCondicionesModalComponent]
})
export class FooterNewComponent implements OnInit {
  public showTerminosyCondiciones: boolean = false;
  public showPrivacyPolicy: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  public showTC($event: boolean): void {
    this.showTerminosyCondiciones = $event;
  }

  public showPP($event: boolean): void {
    this.showPrivacyPolicy = $event;
  }

  public hideModal($event: boolean): void {
    this.showTerminosyCondiciones = $event;
    this.showPrivacyPolicy = $event;
  }
}
